"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProvinceNames = exports.ProvinceCodes = exports.CountryCodes = void 0;
var CountryCodes;
(function (CountryCodes) {
    CountryCodes["AF"] = "AF";
    CountryCodes["AX"] = "AX";
    CountryCodes["AL"] = "AL";
    CountryCodes["DZ"] = "DZ";
    CountryCodes["AS"] = "AS";
    CountryCodes["AD"] = "AD";
    CountryCodes["AO"] = "AO";
    CountryCodes["AI"] = "AI";
    CountryCodes["AQ"] = "AQ";
    CountryCodes["AG"] = "AG";
    CountryCodes["AR"] = "AR";
    CountryCodes["AM"] = "AM";
    CountryCodes["AW"] = "AW";
    CountryCodes["AU"] = "AU";
    CountryCodes["AT"] = "AT";
    CountryCodes["AZ"] = "AZ";
    CountryCodes["BS"] = "BS";
    CountryCodes["BH"] = "BH";
    CountryCodes["BD"] = "BD";
    CountryCodes["BB"] = "BB";
    CountryCodes["BY"] = "BY";
    CountryCodes["BE"] = "BE";
    CountryCodes["BZ"] = "BZ";
    CountryCodes["BJ"] = "BJ";
    CountryCodes["BM"] = "BM";
    CountryCodes["BT"] = "BT";
    CountryCodes["BO"] = "BO";
    CountryCodes["BQ"] = "BQ";
    CountryCodes["BA"] = "BA";
    CountryCodes["BW"] = "BW";
    CountryCodes["BV"] = "BV";
    CountryCodes["BR"] = "BR";
    CountryCodes["IO"] = "IO";
    CountryCodes["BN"] = "BN";
    CountryCodes["BG"] = "BG";
    CountryCodes["BF"] = "BF";
    CountryCodes["BI"] = "BI";
    CountryCodes["CV"] = "CV";
    CountryCodes["KH"] = "KH";
    CountryCodes["CM"] = "CM";
    CountryCodes["CA"] = "CA";
    CountryCodes["KY"] = "KY";
    CountryCodes["CF"] = "CF";
    CountryCodes["TD"] = "TD";
    CountryCodes["CL"] = "CL";
    CountryCodes["CN"] = "CN";
    CountryCodes["CX"] = "CX";
    CountryCodes["CC"] = "CC";
    CountryCodes["CO"] = "CO";
    CountryCodes["KM"] = "KM";
    CountryCodes["CD"] = "CD";
    CountryCodes["CG"] = "CG";
    CountryCodes["CK"] = "CK";
    CountryCodes["CR"] = "CR";
    CountryCodes["CI"] = "CI";
    CountryCodes["HR"] = "HR";
    CountryCodes["CU"] = "CU";
    CountryCodes["CW"] = "CW";
    CountryCodes["CY"] = "CY";
    CountryCodes["CZ"] = "CZ";
    CountryCodes["DK"] = "DK";
    CountryCodes["DJ"] = "DJ";
    CountryCodes["DM"] = "DM";
    CountryCodes["DO"] = "DO";
    CountryCodes["EC"] = "EC";
    CountryCodes["EG"] = "EG";
    CountryCodes["SV"] = "SV";
    CountryCodes["GQ"] = "GQ";
    CountryCodes["ER"] = "ER";
    CountryCodes["EE"] = "EE";
    CountryCodes["ET"] = "ET";
    CountryCodes["FK"] = "FK";
    CountryCodes["FO"] = "FO";
    CountryCodes["FJ"] = "FJ";
    CountryCodes["FI"] = "FI";
    CountryCodes["FR"] = "FR";
    CountryCodes["GF"] = "GF";
    CountryCodes["PF"] = "PF";
    CountryCodes["TF"] = "TF";
    CountryCodes["GA"] = "GA";
    CountryCodes["GM"] = "GM";
    CountryCodes["GE"] = "GE";
    CountryCodes["DE"] = "DE";
    CountryCodes["GH"] = "GH";
    CountryCodes["GI"] = "GI";
    CountryCodes["GR"] = "GR";
    CountryCodes["GL"] = "GL";
    CountryCodes["GD"] = "GD";
    CountryCodes["GP"] = "GP";
    CountryCodes["GU"] = "GU";
    CountryCodes["GT"] = "GT";
    CountryCodes["GG"] = "GG";
    CountryCodes["GN"] = "GN";
    CountryCodes["GW"] = "GW";
    CountryCodes["GY"] = "GY";
    CountryCodes["HT"] = "HT";
    CountryCodes["HM"] = "HM";
    CountryCodes["VA"] = "VA";
    CountryCodes["HN"] = "HN";
    CountryCodes["HK"] = "HK";
    CountryCodes["HU"] = "HU";
    CountryCodes["IS"] = "IS";
    CountryCodes["IN"] = "IN";
    CountryCodes["ID"] = "ID";
    CountryCodes["IR"] = "IR";
    CountryCodes["IQ"] = "IQ";
    CountryCodes["IE"] = "IE";
    CountryCodes["IM"] = "IM";
    CountryCodes["IL"] = "IL";
    CountryCodes["IT"] = "IT";
    CountryCodes["JM"] = "JM";
    CountryCodes["JP"] = "JP";
    CountryCodes["JE"] = "JE";
    CountryCodes["JO"] = "JO";
    CountryCodes["KZ"] = "KZ";
    CountryCodes["KE"] = "KE";
    CountryCodes["KI"] = "KI";
    CountryCodes["KP"] = "KP";
    CountryCodes["KR"] = "KR";
    CountryCodes["KW"] = "KW";
    CountryCodes["KG"] = "KG";
    CountryCodes["LA"] = "LA";
    CountryCodes["LV"] = "LV";
    CountryCodes["LB"] = "LB";
    CountryCodes["LS"] = "LS";
    CountryCodes["LR"] = "LR";
    CountryCodes["LY"] = "LY";
    CountryCodes["LI"] = "LI";
    CountryCodes["LT"] = "LT";
    CountryCodes["LU"] = "LU";
    CountryCodes["MO"] = "MO";
    CountryCodes["MK"] = "MK";
    CountryCodes["MG"] = "MG";
    CountryCodes["MW"] = "MW";
    CountryCodes["MY"] = "MY";
    CountryCodes["MV"] = "MV";
    CountryCodes["ML"] = "ML";
    CountryCodes["MT"] = "MT";
    CountryCodes["MH"] = "MH";
    CountryCodes["MQ"] = "MQ";
    CountryCodes["MR"] = "MR";
    CountryCodes["MU"] = "MU";
    CountryCodes["YT"] = "YT";
    CountryCodes["MX"] = "MX";
    CountryCodes["FM"] = "FM";
    CountryCodes["MD"] = "MD";
    CountryCodes["MC"] = "MC";
    CountryCodes["MN"] = "MN";
    CountryCodes["ME"] = "ME";
    CountryCodes["MS"] = "MS";
    CountryCodes["MA"] = "MA";
    CountryCodes["MZ"] = "MZ";
    CountryCodes["MM"] = "MM";
    CountryCodes["NA"] = "NA";
    CountryCodes["NR"] = "NR";
    CountryCodes["NP"] = "NP";
    CountryCodes["NL"] = "NL";
    CountryCodes["NC"] = "NC";
    CountryCodes["NZ"] = "NZ";
    CountryCodes["NI"] = "NI";
    CountryCodes["NE"] = "NE";
    CountryCodes["NG"] = "NG";
    CountryCodes["NU"] = "NU";
    CountryCodes["NF"] = "NF";
    CountryCodes["MP"] = "MP";
    CountryCodes["NO"] = "NO";
    CountryCodes["OM"] = "OM";
    CountryCodes["PK"] = "PK";
    CountryCodes["PW"] = "PW";
    CountryCodes["PS"] = "PS";
    CountryCodes["PA"] = "PA";
    CountryCodes["PG"] = "PG";
    CountryCodes["PY"] = "PY";
    CountryCodes["PE"] = "PE";
    CountryCodes["PH"] = "PH";
    CountryCodes["PN"] = "PN";
    CountryCodes["PL"] = "PL";
    CountryCodes["PT"] = "PT";
    CountryCodes["PR"] = "PR";
    CountryCodes["QA"] = "QA";
    CountryCodes["RE"] = "RE";
    CountryCodes["RO"] = "RO";
    CountryCodes["RU"] = "RU";
    CountryCodes["RW"] = "RW";
    CountryCodes["BL"] = "BL";
    CountryCodes["SH"] = "SH";
    CountryCodes["KN"] = "KN";
    CountryCodes["LC"] = "LC";
    CountryCodes["MF"] = "MF";
    CountryCodes["PM"] = "PM";
    CountryCodes["VC"] = "VC";
    CountryCodes["WS"] = "WS";
    CountryCodes["SM"] = "SM";
    CountryCodes["ST"] = "ST";
    CountryCodes["SA"] = "SA";
    CountryCodes["SN"] = "SN";
    CountryCodes["RS"] = "RS";
    CountryCodes["SC"] = "SC";
    CountryCodes["SL"] = "SL";
    CountryCodes["SG"] = "SG";
    CountryCodes["SX"] = "SX";
    CountryCodes["SK"] = "SK";
    CountryCodes["SI"] = "SI";
    CountryCodes["SB"] = "SB";
    CountryCodes["SO"] = "SO";
    CountryCodes["ZA"] = "ZA";
    CountryCodes["GS"] = "GS";
    CountryCodes["SS"] = "SS";
    CountryCodes["ES"] = "ES";
    CountryCodes["LK"] = "LK";
    CountryCodes["SD"] = "SD";
    CountryCodes["SR"] = "SR";
    CountryCodes["SJ"] = "SJ";
    CountryCodes["SZ"] = "SZ";
    CountryCodes["SE"] = "SE";
    CountryCodes["CH"] = "CH";
    CountryCodes["SY"] = "SY";
    CountryCodes["TW"] = "TW";
    CountryCodes["TJ"] = "TJ";
    CountryCodes["TZ"] = "TZ";
    CountryCodes["TH"] = "TH";
    CountryCodes["TL"] = "TL";
    CountryCodes["TG"] = "TG";
    CountryCodes["TK"] = "TK";
    CountryCodes["TO"] = "TO";
    CountryCodes["TT"] = "TT";
    CountryCodes["TN"] = "TN";
    CountryCodes["TR"] = "TR";
    CountryCodes["TM"] = "TM";
    CountryCodes["TC"] = "TC";
    CountryCodes["TV"] = "TV";
    CountryCodes["UG"] = "UG";
    CountryCodes["UA"] = "UA";
    CountryCodes["AE"] = "AE";
    CountryCodes["GB"] = "GB";
    CountryCodes["UM"] = "UM";
    CountryCodes["US"] = "US";
    CountryCodes["UY"] = "UY";
    CountryCodes["UZ"] = "UZ";
    CountryCodes["VU"] = "VU";
    CountryCodes["VE"] = "VE";
    CountryCodes["VN"] = "VN";
    CountryCodes["VG"] = "VG";
    CountryCodes["VI"] = "VI";
    CountryCodes["WF"] = "WF";
    CountryCodes["EH"] = "EH";
    CountryCodes["YE"] = "YE";
    CountryCodes["ZM"] = "ZM";
    CountryCodes["ZW"] = "ZW";
})(CountryCodes = exports.CountryCodes || (exports.CountryCodes = {}));
var ProvinceCodes;
(function (ProvinceCodes) {
    ProvinceCodes["AB"] = "AB";
    ProvinceCodes["BC"] = "BC";
    ProvinceCodes["MB"] = "MB";
    ProvinceCodes["NB"] = "NB";
    ProvinceCodes["NL"] = "NL";
    ProvinceCodes["NT"] = "NT";
    ProvinceCodes["NS"] = "NS";
    ProvinceCodes["NU"] = "NU";
    ProvinceCodes["ON"] = "ON";
    ProvinceCodes["PE"] = "PE";
    ProvinceCodes["QC"] = "QC";
    ProvinceCodes["SK"] = "SK";
    ProvinceCodes["YT"] = "YT";
    ProvinceCodes["FOREIGN"] = "FOREIGN";
})(ProvinceCodes = exports.ProvinceCodes || (exports.ProvinceCodes = {}));
var ProvinceNames;
(function (ProvinceNames) {
    ProvinceNames["AB"] = "Alberta";
    ProvinceNames["BC"] = "British Columbia";
    ProvinceNames["MB"] = "Manitoba";
    ProvinceNames["NB"] = "New Brunswick";
    ProvinceNames["NL"] = "Newfoundland and Labrador";
    ProvinceNames["NT"] = "Northwest Territories";
    ProvinceNames["NS"] = "Nova Scotia";
    ProvinceNames["NU"] = "Nunavut";
    ProvinceNames["ON"] = "Ontario";
    ProvinceNames["PE"] = "Prince Edward Island";
    ProvinceNames["QC"] = "Quebec";
    ProvinceNames["SK"] = "Saskatchewan";
    ProvinceNames["YT"] = "Yukon";
})(ProvinceNames = exports.ProvinceNames || (exports.ProvinceNames = {}));
//# sourceMappingURL=addressEnums.js.map